import { generatePath, type RouteObject } from "react-router-dom";

export type WeatherForecastRouteParams = {
    city: string;
    state: string;
    days?: string;
};

export const weatherForecastPath = "/weather-forecast/:city/:state/:days?";

export const weatherForecastPathFor = (params: WeatherForecastRouteParams) => generatePath(weatherForecastPath, params);

export const weatherForecastRoute: RouteObject = {
    path: weatherForecastPath,
    lazy: async () => {
        const { WeatherForecastPage } = await import("@/features/weatherForecast/page");
        return { Component: WeatherForecastPage };
    },
};
